// ─────────────────────────────────────────────────────────────────────────────

export function handleHardwareBackButtonPress(_callback: HardwareBackButtonPressHandler) {
  return () => undefined;
}

// ─── Types ───────────────────────────────────────────────────────────────────

type HardwareBackButtonPressHandler = () => boolean | null | undefined | void;
